import {
    LogLevelEnum,
    RainbowSDK,
    CallsPlugin,
    ConnectionServiceEvents,
    RBEvent,
    ConnectionState, ConnectedUser,
    NetworkInvitation,
    User,
    Conversation,
    Message, BubbleServiceEvents,
} from "rainbow-web-sdk";
import { BubblesPlugin, BubbleConferencePlugin, SendMessageData, FileDocumentPlugin } from "rainbow-web-sdk/lib";
import Config from "../config/config.json";


class RainbowSDKService {
    public rainbowSDK: RainbowSDK;

    constructor() {
        console.log("[RainbowSDKService] starting");
        this.rainbowSDK = RainbowSDK.create({
            appConfig: {
                server: Config.rainbow.server.host,
                applicationId: Config.rainbow.application.appID,
                secretKey: Config.rainbow.application.appSecret
            },
            plugins: [
                BubblesPlugin,
                BubbleConferencePlugin,
                CallsPlugin,
                FileDocumentPlugin
            ],
            autoLogin: true,
            logLevel: LogLevelEnum.WARNING
        })

        this.rainbowSDK.connectionService.subscribe((event: RBEvent) =>
            this.connectionStateChangeHandler(event), ConnectionServiceEvents.RAINBOW_ON_CONNECTION_STATE_CHANGE);

        const bubbleServiceSubscription = this.rainbowSDK.bubbleService?.subscribe((event: RBEvent<BubbleServiceEvents>) => {
            switch(event.name) {
                case BubbleServiceEvents.ON_SERVICE_STARTED:
                    // Received when the bubble service is started and ready to be used
                    // (also fired after loss of network and reconnection).
                    console.log("starteeeed")
                    break;
                case BubbleServiceEvents.ON_BUBBLE_CREATED:
                    // Received when a new bubble is created.
                    console.log("createed")
                    break;
                case BubbleServiceEvents.ON_BUBBLE_DELETED:
                    // Received when a bubble has been deleted by the owner.
                    console.log("deleteed")
                    break;
                case BubbleServiceEvents.ON_CONNECTED_USER_ROLE_UPDATED:
                    // Received when there's an update on the role of the connected user privilege.
                    // (owner, organizer, user)
                    console.log("updateed")
                    break;
                case BubbleServiceEvents.ON_USER_INVITATION_RECEIVED:
                    // Received when the connected user has received an invitation to join a bubble.
                    console.log("receiveed")
                    break;
                case BubbleServiceEvents.ON_USER_INVITATION_DECLINED:
                    // Received when a user has declined the invitation to join the bubble
                    console.log("declineed")
                    break;
                case BubbleServiceEvents.ON_USER_BUBBLE_LEFT:
                    // Received when a user has left the bubble of his own
                    console.log("lefft")
                    break;
                case BubbleServiceEvents.ON_USER_BUBBLE_REMOVED:
                    // Received when a user has been removed from the bubble by the owner or one of the organizers.
                    // Received when the bubble in which the user was a member has been deleted.
                    console.log("removeed")
                    break;
                default: break;
            }
        });
    }

    private connectionStateChangeHandler(event: RBEvent): void {
        const connectionState: ConnectionState = event.data;
        console.info(`[testAppli] onConnectionStateChange ${connectionState.state}`);
    }

    public async loginWithToken(token: string) {
        try {
            const account = this.rainbowSDK.connectionService.logonWithToken(token);
            console.log("[RainbowSDKService] WebRtc Capabilities check done");
            return account;
        } catch(error) {
            console.log("[RainbowSDKService] WebRtc Capabilities check failed: ", error)
            console.log("[RainbowSDKService] Error login in with token ", error);
            throw {
                "data": {
                    "message": "sessionFailed"
                }
            }
        }
    }

    public acceptInvitationReceived(netWorkInvitation: NetworkInvitation) {
        return this.rainbowSDK.userNetwork.acceptInvitation(netWorkInvitation);
    }

    public getConnectedUser(): ConnectedUser | undefined {
        return this.rainbowSDK.connectedUser;
    }

    public getNetworkContacts() {
        return this.rainbowSDK.userNetwork.getUsers();
    }

    public addToNetwork (user: User) {
        return this.rainbowSDK.userNetwork.sendInvitation(user)
    }

    public async getMessagesFromConversation(conversation: Conversation){
        let messages: any[] = [];
        let previousLength = messages.length;
        let continuePolling = true;

        while (continuePolling) {
            try {
                await conversation.getHistoryPage(30);
                let newMessages = conversation.getMessages()

                if (newMessages.length === previousLength) {
                    continuePolling = false;
                    break;
                }
                messages = newMessages;
                previousLength = newMessages.length;
            } catch (e) {
                console.log(e)
                continuePolling = false
                break;
            }
        }

        return messages;
    }

    public markMessageFromConversationAsRead(conversation: Conversation, message: Message) {
        conversation.ackReadMessage(message);
    }

    public getFileDocument(fileId: string) {
        return this.rainbowSDK.fileDocumentService?.searchFileDocuments({name: fileId});
    }

    public sendMessageToConversation(conversation: Conversation, message: string, messageData?: SendMessageData) {
        conversation.sendMessage(message, messageData);
    }
}

export default new RainbowSDKService();
